$(function () {
    $('.TestimonialsCarousel').owlCarousel({
        loop: true,
        nav: false,
        items: 1,
        dots: false,
        navText: [
            '<svg class="icon-chevron-left text-primary"><use xlink:href="#icon-chevron-left"></use></svg>',
            '<svg class="icon-chevron-right text-primary"><use xlink:href="#icon-chevron-right"></use></svg>'
        ],
        margin: 15,
        stageClass: 'owl-stage d-flex',
        responsive: {
            0: {
                items: 1,
                nav: true,
                loop: true
            },
            667: {
                items: 2,
                nav: true,
                loop: true
            },
            992: {
                items: 3,
                nav: false,
                loop: false
            }

        }
    });
});